module.exports = __webpack_public_path__ + "img/NOTUS4U-logo.de7dc055.svg";